import { render, staticRenderFns } from "./AppBarMenuItem.vue?vue&type=template&id=305ab90e"
import script from "./AppBarMenuItem.vue?vue&type=script&lang=js"
export * from "./AppBarMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports